<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="secondaryTagFilter"
        >
          <span class="fs-3">{{
            'configurationOptionModule.secondaryTagFilter' | translate
          }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="secondaryTagFilter">
      <div class="table-responsive card-table">
        <table class="table border-bottom table-light table-sm">
          <thead>
            <tr>
              <th scope="col" id="secTagOrdLabel">
                {{ 'configurationOptionModule.ordinal' | translate }}<br />
              </th>
              <th scope="col" id="secTagActLabel"
                >{{ 'general.active' | translate }}<br
              /></th>
              <th scope="col" id="secTagLevelLabel">
                {{ 'configurationOptionModule.tagLevel' | translate }}<br />
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['nl']"
                id="secTagTitleNl"
              >
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-nl ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['en']"
                id="secTagTitleEn"
              >
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-en ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['fr']"
                id="secTagTitleFr"
              >
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-fr ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span>
              </th>

              <th
                scope="col"
                *ngIf="availableLanguages['de']"
                id="secTagTitleDe"
              >
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-de ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span>
              </th>

              <th scope="col"
                ><span class="visually-hidden">{{
                  'general.actions' | translate
                }}</span></th
              >
            </tr>
          </thead>
          <tbody
            formArrayName="configSets"
            *ngFor="
              let configSets of configSetsFormArray.controls;
              let i = index
            "
          >
            <tr [formGroupName]="i">
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="-"
                  formControlName="ordinal"
                  aria-labelledby="secTagOrdLabel"
                  aria-describedby="secTagOrdError"
                  [attr.aria-invalid]="
                    configSets.controls.ordinal.dirty &&
                    configSets.controls.ordinal.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="secTagOrdError"
                  *ngIf="
                    configSets.controls.ordinal.dirty &&
                    configSets.controls.ordinal.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td>
                <input
                  type="checkbox"
                  class="form-check-input"
                  formControlName="activeState"
                  aria-labelledby="secTagActLabel"
                />
              </td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="-"
                  formControlName="tagLevel"
                  aria-labelledby="secTagLevelLabel"
                  aria-describedby="secTagLevelError"
                  [attr.aria-invalid]="
                    configSets.controls.tagLevel.dirty &&
                    configSets.controls.tagLevel.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="secTagLevelError"
                  *ngIf="
                    configSets.controls.tagLevel.dirty &&
                    configSets.controls.tagLevel.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_nl"
                  formControlName="title_nl"
                  aria-labelledby="secTagTitleNl"
                  aria-describedby="secTagTitleNlError"
                  [attr.aria-invalid]="
                    configSets.controls.title_nl.dirty &&
                    configSets.controls.title_nl.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="secTagTitleNlError"
                  *ngIf="
                    configSets.controls.title_nl.dirty &&
                    configSets.controls.title_nl.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_en"
                  formControlName="title_en"
                  aria-labelledby="secTagTitleEn"
                  aria-describedby="secTagTitleEnError"
                  [attr.aria-invalid]="
                    configSets.controls.title_en.dirty &&
                    configSets.controls.title_en.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="secTagTitleEnError"
                  *ngIf="
                    configSets.controls.title_en.dirty &&
                    configSets.controls.title_en.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_fr"
                  formControlName="title_fr"
                  aria-labelledby="secTagTitleFr"
                  aria-describedby="secTagTitleFrError"
                  [attr.aria-invalid]="
                    configSets.controls.title_fr.dirty &&
                    configSets.controls.title_fr.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="secTagTitleFrError"
                  *ngIf="
                    configSets.controls.title_fr.dirty &&
                    configSets.controls.title_fr.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>

                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_de"
                  formControlName="title_de"
                  aria-labelledby="secTagTitleDe"
                  aria-describedby="secTagTitleDeError"
                  [attr.aria-invalid]="
                    configSets.controls.title_de.dirty &&
                    configSets.controls.title_de.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  id="secTagTitleDeError"
                  *ngIf="
                    configSets.controls.title_de.dirty &&
                    configSets.controls.title_de.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-ghost-secondary"
                  (click)="deleteConfigSetRow(i)"
                  [canSee]="[accessRights.ConfigurationOptions_delete]"
                >
                  <i
                    role="img"
                    class="fa fa-trash-alt"
                    attr.aria-label="{{ 'general.delete' | translate }}"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        class="btn btn-soft-primary btn-sm"
        type="button"
        (click)="addConfigSetRow()"
        [canSee]="[accessRights.Settings_write]"
        [canSee]="[accessRights.ConfigurationOptions_write]"
      >
        {{ 'general.addRow' | translate }}
      </button>

      <div class="d-flex justify-content-end pt-3">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
  <!-- End Card -->
</form>
